import { render, staticRenderFns } from "./activity-item-reply-message.vue?vue&type=template&id=0ce480c1&"
import script from "./activity-item-reply-message.vue?vue&type=script&lang=js&"
export * from "./activity-item-reply-message.vue?vue&type=script&lang=js&"
import style0 from "./activity-item-reply-message.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports